import React from "react";
import "./WorkInProgress.scss";
import { Link } from "react-router-dom";

function WorkInProgress() {
  return (
    <div className="wip-page spacing">
      <div className="container">
        <div className="inner">
          <h5>
            <b>Sorry! For InConveniences.😔😓</b>
          </h5>
          <p>We worked on this page and very soon its available for uses.</p>
          <Link className="btn" to="/">
            Goto Home Page
          </Link>
        </div>
      </div>
    </div>
  );
}

export default WorkInProgress;
